import { render } from "./MypageReports.vue?vue&type=template&id=223b9af5&scoped=true&ts=true"
import script from "./MypageReports.vue?vue&type=script&lang=ts"
export * from "./MypageReports.vue?vue&type=script&lang=ts"

import "./MypageReports.vue?vue&type=style&index=0&id=223b9af5&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223b9af5"]])

export default __exports__